import { FC, useEffect, useState } from 'react';
import { Comment, Review } from '../../interfaces/types';
import { Divider, List, ListItem, Typography } from '@mui/material';
import CommentListItem from './CommentListItem';
import { useCommentContext } from '../../providers/CommentProvider';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

interface CommentListProps {
    review: Review;
}

const CommentList: FC<CommentListProps> = ({ review }) => {
    const [comments, setComments] = useState<Comment[]>([]);
    const { getCommentsForReview } = useCommentContext();

    useEffect(() => {
        setComments(getCommentsForReview(review));
    }, [review, getCommentsForReview]);

    return (
        <List
            sx={{
                width: '100%',
                position: 'relative',
                overflow: 'auto',
                maxHeight: 400,
            }}

        >

            {comments.sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()).map((comment) => 
            <ListItem key={comment.id} sx={{ display: 'flex', flexDirection: 'column'}}>
                <Divider component="div" role="presentation" sx={{ align:'center', justifyContent:'center',width: '100%'}}>
                    <Typography variant='caption'>{dayjs(comment.createdAt).fromNow()}</Typography>
                </Divider>
                <CommentListItem key={comment.id} comment={comment} />
            </ListItem>)}
        </List>
    );
};

export default CommentList;